import { React } from 'react';
import ClipLoader from "react-spinners/ClipLoader";

const AppLoader = props => {
  const { color='#1A31A9', loading=true, size=100 } = props;
  return <ClipLoader color={color} loading={loading} size={size} />;
};

export default AppLoader;